import { makeAutoObservable } from "mobx";

import type { AgentThreadVo } from "@/api";
import { api } from "@/api";

export type CommunityThread = AgentThreadVo;

class CommunityStore {
  threads: CommunityThread[] = [];
  loading = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async fetchCommunityThreads() {
    if (this.loading) {
      return;
    }

    this.loading = true;
    try {
      const response = await api.threads.listCommunityThreads({
        offset: 0,
        limit: 100,
      });
      this.threads = response.data.list ?? [];
    } finally {
      this.loading = false;
    }
  }
}

export const communityStore = new CommunityStore();
